// Actions.
export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const FLUSH_CART = "FLUSH_CART";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_REQUEST_SUCCESS = "LOGIN_REQUEST_SUCCESS";
export const LOGIN_REQUEST_FAILURE = "LOGIN_REQUEST_FAILURE";
export const CHECKOUT_REQUEST = "CHECKOUT_REQUEST";
export const CHECKOUT_REQUEST_SUCCESS = "CHECKOUT_REQUEST_SUCCESS";
export const CHECKOUT_REQUEST_FAILURE = "CHECKOUT_REQUEST_FAILURE";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_FAILURE = "LOGOUT_USER_FAILURE";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const TOGGLE_SHOW_PRICE = "TOGGLE_SHOW_PRICE";
export const TOGGLE_SHOW_UVP = "TOGGLE_SHO_UVP";
export const CONTACT_REQUEST = "CONTACT_REQUEST";
export const CONTACT_REQUEST_SUCCESS = "CONTACT_REQUEST_SUCCESS";
export const CONTACT_REQUEST_FAILURE = "CONTACT_REQUEST_FAILURE";
export const CONTACT_DRAFT = "CONTACT_DRAFT";



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js